import { render } from "./Accordion.vue?vue&type=template&id=74e71e42&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import "./Accordion.vue?vue&type=style&index=0&id=74e71e42&scoped=true&lang=scss"
import "./Accordion.vue?vue&type=style&index=1&id=74e71e42&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e71e42"]])

export default __exports__